import {Component} from '@angular/core';

@Component({
    selector: 'db-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss'],
    standalone: false
})
export class CustomersComponent {

}
